<template>
  <v-dialog :value="show" width="1100" persistent>
    <v-stepper v-model="stepper" non-linear>
      <v-stepper-header>
        <template v-for="(step, index) in trame">
          <v-divider v-if="index !== 0" :key="'step_divider_' + index"></v-divider>
          <v-stepper-step
            :complete="stepper > index + 1"
            :step="index + 1"
            :key="'step_' + index"
          >
            {{ $t('Help.GetStarted.' + step.title) }}
          </v-stepper-step>
        </template>

        <v-divider></v-divider>
      </v-stepper-header>

      <v-stepper-items>
        <v-stepper-content v-for="(step, index) in trame" :step="index + 1" :key="'step_content_' + index">
          <v-card
            class="mb-12"
            color="transparent"
            height="500"
            flat
          >
            <v-slide-x-transition group>
              <template v-for="(item, index) in step.items">
                <v-row v-if="time >= index * 2" :key="'step_content_item_' + index" >
                  <v-col cols="6" :order="index % 2 === 0 ? 1 : 2">
                    <v-card-title v-text="$t('Help.GetStarted.' + item.title)" />
                    <v-card-text v-if="item.description" v-text="$t('Help.GetStarted.' + item.description)" />
                  </v-col>
                  <v-col cols="6" :order="index % 2 === 0 ? 2 : 1">
                    <v-img v-if="item.src" :src="require('@/assets/help/' + item.src)" max-height="225" contain></v-img>
                  </v-col>
                </v-row>
              </template>
            </v-slide-x-transition>
          </v-card>

          <v-btn 
            v-if="stepper > 1" 
            icon 
            class="mr-2"
            @click="stepper--" 
          >
            <v-icon>arrow_back</v-icon>
          </v-btn>

          <v-btn
            v-if="stepper < trame.length"
            color="primary"
            @click="stepper++"
          >
            <v-icon class="mr-3">arrow_forward</v-icon>
            {{$t('Global.Action.continue')}}
          </v-btn>

          <v-btn
            v-else
            color="primary"
            @click="$emit('finish')"
          >
            <v-icon left>check</v-icon>
            {{$t('Global.Action.finish')}}
          </v-btn>

        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
  </v-dialog>
</template>

<script>
import {interval, getStarted} from '@/config/help'

export default {
  name: 'HelpModal',
  props: {
    show: { type: Boolean, required: false }
  },
  data: () => ({
    stepper: 1,
    timer: null,
    time: 0
  }),
  computed: {
    trame() {
      return getStarted
    }
  },
  watch: {
    stepper () {
      this.time = 0
    },
    show (value) {
      this.time = 0
      if (this.timer) clearInterval(this.timer)
      if (value) {
        this.timer = setInterval(() => {
          this.time++
        }, interval)
      }
    }
  },
  beforeDestroy() {
    if (this.timer) clearInterval(this.timer)
  }

}
</script>